import React, { Fragment } from "react";
import { H4, P, } from "../../../AbstractElements";

const FormHeader = () => {
  return (
    <Fragment>
      <div className="login-header text-center">
        <H4>{"Sistem Informasi Kepegawaian"}</H4>
        <P>{"Silakan login ke dalam akun"}</P>
      </div>
    </Fragment>
  );
};
export default FormHeader;
